import React from "react";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";

import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { getPersonFullName } from "utils/person";
import useStyles from "./styles";

interface Props {
  injection: racehorse360.IInjection;
}

const VaccineDetailsList = (props: Props) => {
  const { injection = {} } = props;
  const classes = useStyles();

  const items = [
    {
      label: "Vaccine Name",
      value: injection.medicine?.name
    },
    {
      label: "Manufacturer",
      value: injection.manufacturer
    },
    {
      label: "Vaccine Date",
      value:
        injection.injectionDate &&
        format(parseISO(injection.injectionDate), "M/dd/yyyy")
    },
    {
      label: "Expiration Date",
      value:
        injection.vaccination?.expirationDate &&
        format(parseISO(injection.vaccination?.expirationDate), "M/dd/yyyy")
    },
    {
      label: "Reporter",
      value:
        injection.dataSource ===
        racehorse360.InjectionDataSource.INJECTION_DATA_SOURCE_RH360
          ? getPersonFullName(injection.createdBy, "%F %L")
          : "Incompass"
    },
    {
      label: "Comment",
      value: injection.comment
    }
  ];

  return (
    <>
      <div>
        {items.map((item, index) => (
          <React.Fragment key={item.label}>
            <ListItem className={classes.listItem}>
              <Typography className={classes.listItemLabel}>
                {item.label}
              </Typography>
              <Typography className={classes.listItemValue}>
                {item.value || "N/A"}
              </Typography>
            </ListItem>
            {index < items.length && <Divider light />}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default VaccineDetailsList;
